(function () {
  "use strict";

  /*
    SPARC CONFIGURATOR — PHASE 1 LAUNCH / ACCESSORIES OFF V1
  */

  if (window.__SPARC_PHASE1_ACCESSORIES_OFF_V1__) return;
  window.__SPARC_PHASE1_ACCESSORIES_OFF_V1__ = true;

  var PANEL_IDS = [
    "sparc-muscle-configurator",
    "sparc-muscle-round-configurator",
    "sparc-driver-configurator",
    "sparc-heritage-configurator",
    "sparc-classic-3100-configurator",
    "sparc-classic-squarebody-configurator",
    "sparc-garage-configurator"
  ];

  var observer = null;
  var timer = null;
  var clearing = false;

  function clean(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalize(value) {
    return clean(value).toLowerCase();
  }

  function activePanel() {
    for (var i = 0; i < PANEL_IDS.length; i++) {
      var panel = document.getElementById(PANEL_IDS[i]);
      if (panel) return panel;
    }
    return null;
  }

  function hide(node) {
    if (!node) return;
    node.style.setProperty("display", "none", "important");
    node.setAttribute("aria-hidden", "true");
    node.dataset.sparcPhase1AccessoriesHidden = "true";
  }

  function dispatchChange(node) {
    if (!node) return;

    node.dispatchEvent(new Event("input", { bubbles: true }));
    node.dispatchEvent(new Event("change", { bubbles: true }));

    if (window.jQuery && typeof window.jQuery === "function") {
      try {
        window.jQuery(node).trigger("change");
      } catch (e) {}
    }
  }

  function setSelectOff(root, candidates) {
    var select =
      root.tagName === "SELECT"
        ? root
        : root.querySelector("select");

    if (!select) return false;

    var options = Array.prototype.slice.call(
      select.querySelectorAll("option")
    );

    var target = null;

    for (var i = 0; i < candidates.length && !target; i++) {
      var wanted = normalize(candidates[i]);

      target =
        options.find(function (opt) {
          return (
            normalize(opt.value) === wanted ||
            normalize(opt.getAttribute("data-display-val")) === wanted ||
            normalize(opt.textContent) === wanted
          );
        }) || null;
    }

    if (!target) return false;

    if (normalize(select.value) !== normalize(target.value)) {
      select.value = target.value;
      target.selected = true;
      dispatchChange(select);
    }

    return true;
  }

  function setInputsOff(root, candidates) {
    var inputs = Array.prototype.slice.call(
      root.querySelectorAll(
        'input[type="radio"], input[type="checkbox"]'
      )
    );

    if (!inputs.length) return false;

    for (var i = 0; i < candidates.length; i++) {
      var wanted = normalize(candidates[i]);

      var target =
        inputs.find(function (input) {
          return (
            normalize(input.value) === wanted ||
            normalize(input.getAttribute("data-display-val")) === wanted
          );
        });

      if (target) {
        if (!target.checked) {
          target.click();
        }

        dispatchChange(target);
        return true;
      }
    }

    if (
      inputs.length === 1 &&
      inputs[0].type === "checkbox" &&
      inputs[0].checked
    ) {
      inputs[0].checked = false;
      dispatchChange(inputs[0]);
      return true;
    }

    return false;
  }

  function forceOff(selectorId, candidates) {
    var root = document.getElementById(selectorId);
    if (!root) return;

    if (setSelectOff(root, candidates)) return;
    setInputsOff(root, candidates);
  }

  function clearKnownAccessories() {
    if (clearing) return;

    clearing = true;

    try {
      forceOff(
        "sparc-muscle-column-spacer",
        ["None", "No"]
      );

      forceOff(
        "sparc-shared-care-kit",
        ["No", "None"]
      );
    } finally {
      window.setTimeout(function () {
        clearing = false;
      }, 80);
    }
  }

  function hideTopAccessoryTabs(panel) {
    var candidates = Array.prototype.slice.call(
      panel.querySelectorAll(
        ".sparc-config-tab, [role='tab']"
      )
    );

    candidates.forEach(function (tab) {
      var section = normalize(
        tab.getAttribute("data-section") ||
        tab.getAttribute("data-sparc-completion-section")
      );

      var text = normalize(tab.textContent);

      if (
        section === "accessories" ||
        text.indexOf("accessories") !== -1
      ) {
        hide(tab);
      }
    });
  }

  function hideAccessoryAccordions(panel) {
    var sections = Array.prototype.slice.call(
      panel.querySelectorAll(
        '.sparc-accordion[data-section="accessories"]'
      )
    );

    sections.forEach(hide);
  }

  function hideAccessorySummaryRows(panel) {
    var rows = Array.prototype.slice.call(
      panel.querySelectorAll(".sparc-summary-row")
    );

    rows.forEach(function (row) {
      var label = row.querySelector(".sparc-summary__label");
      var text = normalize(
        label ? label.textContent : row.textContent
      );

      if (
        text.indexOf("accessories") !== -1 ||
        text.indexOf("column spacer") !== -1 ||
        text.indexOf("spacer finish") !== -1 ||
        text.indexOf("care kit") !== -1
      ) {
        hide(row);
      }
    });
  }

  function applyLaunchMode() {
    timer = null;

    var panel = activePanel();
    if (!panel) return;

    panel.dataset.sparcPhase1Accessories = "off";

    hideTopAccessoryTabs(panel);
    hideAccessoryAccordions(panel);
    hideAccessorySummaryRows(panel);
    clearKnownAccessories();
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(applyLaunchMode, 50);
  }

  function start() {
    applyLaunchMode();

    observer = new MutationObserver(function () {
      if (!clearing) {
        schedule();
      }
    });

    observer.observe(
      document.body,
      {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
          "class",
          "style",
          "hidden"
        ]
      }
    );

    [150, 350, 700, 1200, 2000].forEach(function (delay) {
      window.setTimeout(applyLaunchMode, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
